module.exports = __webpack_public_path__ + "img/img (10).fa916753.jpg";